import { render, staticRenderFns } from "./ClientSearch.vue?vue&type=template&id=5e41d581&scoped=true"
import script from "./ClientSearch.vue?vue&type=script&lang=js"
export * from "./ClientSearch.vue?vue&type=script&lang=js"
import style0 from "./ClientSearch.vue?vue&type=style&index=0&id=5e41d581&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e41d581",
  null
  
)

export default component.exports